<script setup>
import Card from '@/Components/Card/Card.vue';
import Copyright from '@/Components/Copyright.vue';
import ContactUsButton from '@/Layouts/Partials/ContactUsButton.vue';
import SignUpButton from '@/Layouts/Partials/SignUpButton.vue';
import { usePage } from '@inertiajs/vue3';

const { branding } = usePage().props;
</script>

<template>
  <Card
    v-if="branding?.footer?.title"
    class="flared-footer bg-highlight text-highlight-content relative mt-2 overflow-hidden md:mt-8"
  >
    <div class="relative z-10 items-center justify-between md:flex">
      <div class="mr-10 md:w-3/4">
        <h3 class="mb-2 text-lg font-bold">{{ branding.footer.title }}</h3>
        <p>
          {{ branding.footer.description }}
        </p>
      </div>
      <div class="mt-5 flex shrink-0 justify-between gap-4 md:mt-0">
        <ContactUsButton />
        <SignUpButton />
      </div>
    </div>
  </Card>
  <Copyright />
</template>

<style scoped>
.flared-footer::before {
  width: 380px;
  height: 380px;
  position: absolute;
  right: 300px;
  top: -230px;
  border-radius: 380px;
  opacity: 0.3;
  background: #0073ea;
  filter: blur(100px);
  content: '';
}

.flared-footer::after {
  width: 301px;
  height: 301px;
  position: absolute;
  right: 220px;
  bottom: -230px;
  border-radius: 301px;
  opacity: 0.4;
  background: #00c9bd;
  filter: blur(100px);
  content: '';
}
</style>
